import {LocalizedDictionary} from '../Translator';

export default {
  "DD": "DD",
  "Discontinued": "Prenehano",
  "Spare part list": "Seznam rezervnih delov",
  "Download Excel": "Prenesite Excel",
  "Recent search list": "Seznam nedavnih iskanj",
  "No data": "Ni podatkov",
  "spare part": "rezervni del",
  "none": "ni",
  "no value": "brez vrednosti",
  "No results found": "Ni bilo najdenih rezultatov",
  "Spare parts for": "Rezervni deli za",
  "Could not load cumulated data": "Ni bilo mogoče naložiti kumulativnih podatkov",
  "commissioning part": "del za začetek obratovanja",
  "wear part": "nosljivi del",
  "Search": "Iskanje",
  "Tk": "Tk",
  "Spare part number": "Številka nadomestnega dela",
  "drawing": "risanje",
  "Products for": "Izdelki za",
  "Available": "Na voljo",
  "MM": "MM",
  "The entered order code is invalid": "Vnesena koda naročila je neveljavna",
  "Recommended": "Priporočeno",
  "No data available for the entered search parameters": "Za vnesene iskalne parametre ni na voljo nobenih podatkov",
  "Search spare parts": "Iskanje rezervnih delov",
  "Order code / product root / serial number": "Koda naročila / koren izdelka / serijska številka",
  "Characteristic": "Značilnosti",
  "Please enter an order code": "Prosimo, vnesite kodo naročila",
  "Regarding quality- and security-aspects Endress+Hauser strongly recommends the exclusive use of genuine Endress+Hauser spare parts. The instrument may only be maintained and repaired by qualified personnel. The device documentation, applicable standards and legal requirements as well as any certificates have to be observed!": "V zvezi s kakovostnimi in varnostnimi vidiki Endress+Hauser močno priporoča izključno uporabo originalnih nadomestnih delov Endress+Hauser. \nInstrument lahko vzdržuje in popravlja le usposobljeno osebje. \nUpoštevati je treba veljavne standarde in zakonske zahteve ter morebitne certifikate iz dokumentacije naprave!",
  "Maintenance advice": "Nasveti za vzdrževanje",
  "Mo.": "Mo.",
  "For which product(s) can my spare part be used? Filling in the spare part order code (e.g. 71002865 or XPD0024) shows the relevant devices this spare part can be used in.": "Za katere izdelke se lahko uporabi moj nadomestni del? Z vpisom kode naročila rezervnega dela (npr. 71002865 ali XPD0024) se prikažejo ustrezne naprave, v katerih se ta rezervni del lahko uporablja.",
  "tool": "orodje",
  "Production numbers": "Proizvodne številke",
  "New alternative": "Nova alternativa",
  "There are no items selected. Please use the checkboxes to make your selection": "Izbranih ni nobenih elementov. Za izbiro uporabite potrditvena polja",
  "Service segmentation": "Segmentacija storitev",
  "Seg": "Seg",
  "Valid": "Velja",
  "Pos": "Položaj",
  "Value": "Vrednost",
  "service segmentation 2": "Deli, ki zahtevajo osnovno znanje. Predpogoj je uspešna udeležba na osnovnem usposabljanju E+H.",
  "Phase out date": "Datum postopnega opuščanja",
  "service segmentation 1": "Deli, ki zahtevajo osnovno znanje.",
  "Which spare parts are available for my product? Filling in the order code (e.g. FTC260-AA2A1 or PMC51-BA21JB1CGBTDJB) or the product id (e.g. FTC260 or 83F50) shows the relevant spare parts.": "Kateri rezervni deli so na voljo za moj izdelek? Z vpisom kode naročila (npr. FTC260-AA2A1 ali PMC51-BA21JB1CGBTDJB) ali identifikatorja izdelka (npr. FTC260 ali 83F50) se prikažejo ustrezni rezervni deli.",
  "Set filter": "Nastavite filter",
  "Search date": "Datum iskanja",
  "Group": "Skupina",
  "Warning": "Opozorilo",
  "Description": "Opis",
  "Cancel": "Prekliči",
  "service segmentation 4": "Deli za popravilo v tovarni. Strokovno znanje je obvezno.",
  "service segmentation 3": "Deli, ki zahtevajo specializirano znanje. Predpogoj je uspešna udeležba na naprednem usposabljanju E+H.",
  "Drawing Position Number": "Številka položaja risbe",
  "Spare parts search": "Iskanje rezervnih delov",
  "Confirm": "Potrdite",
  "Ordercode too short": "Prekratka koda naročila",
  "Product status": "Stanje izdelka",
  "Open": "Odpri",
  "Clear": "Jasno",
  "PDF file with assembly instructions": "Datoteka PDF z navodili za sestavljanje",
  "Search products": "Iskanje izdelkov",
  "Export": "Izvoz",
  "Production date": "Datum izdelave",
  "Order stop": "Ustavitev naročila",
  "Calibration until": "Kalibracija do",
  "PDF file with compatibility information": "Datoteka PDF z informacijami o združljivosti",
  "Add selection to cart": "Dodajanje izbora v košarico",
  "Mounting advices": "Nasveti za montažo",
  "Recommended parts only": "Samo priporočeni deli",
  "not applicable": "se ne uporablja",
  "accessories": "dodatki",
  "Cumulative spare parts list": "Kumulativni seznam rezervnih delov",
  "YYYY": "LLLLL",
  "Title": "Naslov",
  "Error": "Napaka",
  "Ordercode too long": "Predolga koda naročila",
  "Functions": "Funkcije",
  "Rec": "Rec",
  "Type": "Tip",
  "Spare sensor until": "Rezervno tipalo do",
  "Spare parts until": "Rezervni deli do",
  "Filter": "Filter",
  "Check all": "Preverite vse",
  "Order code": "Koda naročila",
  "Repair until": "Popravilo do",
  "Tag": "Oznaka",
  "Ok": "Ok",
  "Category code": "Koda kategorije",
  "Phase out": "Postopna ukinitev",
  'Compatibility advices': 'Dodatni dokumenti',
  'Co.': 'Dod. dok.',
} as LocalizedDictionary;
